<course-form-general
  *ngIf="course$ | async"
  (onSubmit)="onSubmit($event)"
  [course]="course$ | async"
>
</course-form-general>
